import { Select } from "@commonlibs";
import styled, { css } from "styled-components";

export const DatePickerYearSelectRoot = styled(Select)(
    ({ theme }) => css`
        .Select {
            .SelectDisplay {
                border: none;
                padding: 0;
                background-color: transparent;
            }
            .SelectMenu {
                width: auto;
                margin-top: -${theme.spacing["3"]};
            }
            .SelectItem {
                height: 3rem;
            }
        }
    `,
) as typeof Select;
